import { ACTIVE_CONSUMER_GROUPS } from '@constants/consumer_groups'

export const getIcon = (id) => {
  const currentCCG = ACTIVE_CONSUMER_GROUPS.find((ccg) => ccg.id === id)
  if (!currentCCG) return null

  return currentCCG.icon
}
